// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"3512ddce","305":"aa7d39c7","400":"80cba97d","685":"a54c4901","763":"fdf7d285"}[chunkId] + ".chunk.css";
};